var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ku-drift",on:{"click":_vm.onHref}},[_c('div',{staticClass:"money"},[_c('span',[_vm._v("余额")]),_c('span',[_vm._v(_vm._s(_vm.money))]),_c('span',[_vm._v("元")])]),_c('div',{staticClass:"tit"},[_vm._v("薅一把")])])
}
var staticRenderFns = []

export { render, staticRenderFns }